<template>
  <el-dialog
    title="Diferencia en CXC"
    :visible.sync="VisibleDialog"
    @closed="onClose"
    :modal="false"
  >
    <el-row>
      <el-button type="warning" round @click="onCxcUpdate"
        >Actualizar</el-button
      >
      <rabbey-toolbox
        filter-placeholder="Busqueda"
        filterables
        @filter-search="search = $event"
      />
    </el-row>
    <el-row>
      <rabbey-table3
        ref="companyTable"
        :search="search"
        :border="true"
        :stripe="true"
        :columns="CxC_Columns"
        v-loading="loading_Data"
        :data="CxCDiffData"
        :class-table="{
          'table-box': true,
          'card-base': true,
          'card-shadow--medium': false
        }"
        :show-summary="true"
        :pageSizes="[10, 20, 50, 100, 200, 500]"
        :summary-method="getSummaries"
      />
    </el-row>
  </el-dialog>
</template>

<script>
import { CxC_Columns } from "@/views/apps/ncfmovil/columnsTables/DetailedCxCDiffColumns.js";
import { formatMonto } from "@/utils";

export default {
  name: "CxCDiferenceDetail",
  props: {
    RowData: {
      type: Object,
      default: () => {}
    },
    DialogShow: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      diffCxCDialogShow: false,
      CxC_Columns,
      loading_Data: false,
      CxCDiffData: [],
      search: "",
      VisibleDialog: this.DialogShow
    };
  },
  computed: {
    /*
    diffCxCDialogShow(value) {
        return this.DialogShow
    }
    */
  },
  mounted() {
    this.GetCxCDiffData(this.RowData.clientid);
  },
  watch: {
    async DialogShow(val) {
      if (val === true) {
        await this.GetCxCDiffData();
        this.VisibleDialog = val;
      } else {
        //console.log("DialogShow: ", val)
        this.VisibleDialog = val;
      }
    }
  },
  methods: {
    async GetCxCDiffData(ClienID = null) {
      //console.log("Entro a GetCxCDiffData");
      //console.log("RowData: ", this.RowData);
      /*
      const params = {
        headers: {
          'Accept': 'application/octet-stream',
          'Content-Type': 'application/octet-stream'
        },
        params:{
        EmpresaId: this.RowData.supplierId,
        ClientId: this.RowData.clientid
        }
      }
      */
      this.loading_Data = true;
      this.$http
        .get(
          `/api/tennos/GetCxCDiferenceDetail?ClientId=${ClienID}&EmpresaId=${this.RowData.supplierId}&Rnc=${this.RowData.RNC_Cliente}&Rnc_Empresa=${this.RowData.RNC_Empresa}`
        )
        .then((resp) => {
          //console.log("CxCDiffData : ", resp)
          this.CxCDiffData = resp.data;
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.loading_Data = false;
        });
    },
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index < 6) {
          return;
        }
        if (index === 6) {
          sums[index] = "Totales";
          return;
        }
        const values = data.map((item) => Number(item[column.property]));
        if (!values.every((value) => isNaN(value))) {
          sums[index] = formatMonto(
            values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0)
          );
        } else {
          sums[index] = "";
        }
      });

      return sums;
    },
    onClose() {
      this.$emit("OnDialogClose", false);
    },
    onCxcUpdate() {
      this.$confirm(
        "Esta apunto de actualizar el monto en CxC del cliente?",
        "Cuidado",
        {
          confirmButtonText: "OK",
          cancelButtonText: "Cancel",
          type: "warning"
        }
      )
        .then(() => {
          let config = {
            ClientId: this.RowData.clientid,
            EmpresaId: this.RowData.supplierId,
            Rnc: this.RowData.RNC_Cliente,
            Rnc_Empresa: this.RowData.RNC_Empresa
          };
          this.$http
            .post(`/api/tennos/PostUpdateCxCNFCMovil`, config)
            .then((resp) => {
              //console.log("CxCDiffData : ", resp)
              this.CxCDiffData = resp.data;
            })
            .catch((e) => {
              console.error(e);
            })
            .finally(() => {
              this.loading_Data = false;
            });
          this.$message({
            type: "success",
            message: "Monto Actualizado"
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "Actualizacion Cancelada"
          });
        });
    }
  }
};
</script>
